import RegistryBase from "./registry-base";
export default class Registry extends RegistryBase {
}
